import { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import SwalMessage from "../_Components/SwalMessage";
import SelectComponent from "../_Components/ReactSelectComponent";

export const CopyPromoCategoryCommissionModal = ({
  showModalCopyPromoCategoryCommision,
  setShowModalCopyPromoCategoryCommision,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm();
  const [promoCategoryCommisionList, setPromoCategoryCommisionList] = useState([]);

  const handleClose = () => {
    setShowModalCopyPromoCategoryCommision(false);
  };
  useEffect(() => {
    (async () => {
      try {
        const promoCategoryCommisionList = await ApiPromocategorycommision.getAllPromoCategoryCommission();
        setPromoCategoryCommisionList(promoCategoryCommisionList);
      } catch (error) {
      }
    })();
  }, [])
  const onSubmit = async (data) => {
    try {
      data.sourcePromoCategoryCommisionId = data?.sourcePromoCategoryCommissionId?.value;
      data.desPromoCategoryCommisionIds = data?.desPromoCategoryCommissionIds?.map((item) => item?.value);
      let response = await ApiPromocategorycommision.copyPromoCategoryCommision(data);
      if (response.succeeded) {
        handleClose();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  // const handleChangeSourcePromoCategoryCommissionId = (e) => {
  //   const selectedId = e.value;
  //   const promoCategoryCommisionListFromSelectedId = promoCategoryCommisionList.filter((item) => item.id != selectedId);
  //   setValue("sourcePromoCategoryCommissionId", e);
  //   setValue("desPromoCategoryCommissionIds", undefined);
  //   setPromoCategoryCommisionList([...promoCategoryCommisionListFromSelectedId]);
  // };

  return (
    <div>
      <Modal centered size="md" show={showModalCopyPromoCategoryCommision} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>کپی آیتم های گروه کمیسیون تخفیف </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name="sourcePromoCategoryCommissionId"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectComponent
                    placeholder=" گروه کمیسیون منبع"
                    className="mt-0"
                    options={promoCategoryCommisionList?.map((item) => ({
                      value: item.id,
                      label: item.id + "-" + item.name,
                    }))}
                    field={field}
                  // onChange={handleChangeSourcePromoCategoryCommissionId}
                  />
                )}
              />
              {errors.sourcePromoCategoryCommissionId && (
                <div className="text-danger mt-2">** گروه کمیسیون منبع خود را انتخاب کنید</div>
              )}
            </Col>
            <Col xs="12">
              <Controller
                name="desPromoCategoryCommissionIds"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-4"
                    placeholder="گروه کمیسیون مقصد"
                    options={promoCategoryCommisionList?.map((item) => ({
                      value: item.id,
                      label: item.id + "-" + item.name,
                    }))}
                    field={field}
                    isMulti
                  />
                )}
              />
              {errors.desPromoCategoryCommissionIds && (
                <div className="text-danger mt-2"> ** گروه های کمیسیون مقصد خود را انتخاب کنید</div>
              )}
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
